import {Data, Int} from '@store/@types/util';

export type FolderId = Int;
interface FolderInterface {
  id: FolderId;
  name: string;
  unviewedCount: Int;
}

export default class Folder extends Data<FolderInterface>({
  id: undefined,
  name: undefined,
  unviewedCount: undefined,
}) {
  isInbox() {
    return this.name === 'Inbox';
  }
  isOutbox() {
    return this.name === 'Outbox';
  }
  isTrash() {
    return this.name === 'Trash';
  }
}
